namespace TabAurous.OMS {
    export namespace DesignService {
        export const baseUrl = 'OMS/Design';

        export declare function Create(request: Serenity.SaveRequest<DesignRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DesignRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DesignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DesignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function DesignList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<DesignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/Design/Create",
            Update = "OMS/Design/Update",
            Delete = "OMS/Design/Delete",
            Retrieve = "OMS/Design/Retrieve",
            List = "OMS/Design/List",
            DesignList = "OMS/Design/DesignList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'DesignList'
        ].forEach(x => {
            (<any>DesignService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
